<template>
  <div class="upTile" :class="{ 'upTile--active': active }" @click="$emit('open')">
    <div class="upTile__image">
      <img v-if="job.thumb" :src="job.thumb" alt="" :class="{ 'upTile__img--dim': running }" loading="lazy" />
      <div v-if="running" class="upTile__overlay">
        <v-progress-circular indeterminate size="20" width="2" color="white" />
        <span>{{ statusLabel }}</span>
      </div>
      <div v-else-if="job.status === 'failed'" class="upTile__overlay upTile__overlay--failed">
        <v-icon small color="#ff8a80">mdi-alert-circle-outline</v-icon>
        <span>{{ job.error || "Fehlgeschlagen" }}</span>
      </div>
      <span class="upTile__source">{{ source }}</span>
      <span v-if="scoreMin !== null" class="upTile__score" :style="{ color: scoreColor }" :title="scoreTitle">{{ scoreMin }}</span>
    </div>
    <div class="upTile__meta">
      <span>{{ time }}<template v-if="job.transparent"> · α</template></span>
      <span>{{ cost }}</span>
    </div>
  </div>
</template>

<script>
import { formatUsd, isJobRunning, jobStatusLabel, jobTime, scoreColor, sourceLabel } from "@/upscaleJobs";

export default {
  name: "UpscaleJobTile",
  props: {
    job: { type: Object, required: true },
    active: { type: Boolean, default: false },
  },
  computed: {
    running() {
      return isJobRunning(this.job);
    },
    statusLabel() {
      return jobStatusLabel(this.job);
    },
    scoreMin() {
      const s = this.job.taskScore;
      return s && s.min !== null && s.min !== undefined ? s.min : null;
    },
    scoreColor() {
      return scoreColor(this.scoreMin, this.job.taskScoreLimit || 85);
    },
    scoreTitle() {
      const s = this.job.taskScore || {};
      return s.limitedBy ? `Niedrigster Wert: ${s.limitedBy} · Durchschnitt ${s.avg}` : "";
    },
    time() {
      return jobTime(this.job);
    },
    cost() {
      return this.job.costUsd ? formatUsd(this.job.costUsd) : "";
    },
    source() {
      return sourceLabel(this.job.source);
    },
  },
};
</script>

<style lang="scss" scoped>
.upTile {
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: box-shadow 0.15s, border-color 0.15s;

  &:hover,
  &--active {
    border-color: #7b5cd6;
    box-shadow: 0 4px 16px rgba(123, 92, 214, 0.18);
  }
  &__image {
    position: relative;
    aspect-ratio: 4 / 5;
    background: #f4f3f7;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  &__img--dim {
    opacity: 0.45;
  }
  &__overlay {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px;
    background: rgba(20, 16, 34, 0.45);
    color: #fff;
    font-size: 11.5px;
    font-weight: 700;
    text-align: center;

    &--failed {
      background: rgba(20, 16, 34, 0.7);
      font-weight: 500;
    }
  }
  &__source,
  &__score {
    position: absolute;
    top: 6px;
    padding: 1px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
  }
  &__source {
    left: 6px;
    background: rgba(255, 255, 255, 0.9);
    color: #6a4fc4;
  }
  &__score {
    right: 6px;
    background: rgba(20, 16, 34, 0.8);
    font-size: 12.5px;
  }
  &__meta {
    display: flex;
    justify-content: space-between;
    padding: 6px 10px;
    font-size: 11.5px;
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>
